(function () {
  function init(ctrl) {
    if (ctrl.hasAttribute('data-sp-feed-ready')) return;
    ctrl.setAttribute('data-sp-feed-ready', '');
    var section = ctrl.closest('.collection-slider-row');
    if (!section) return;

    var override = new URLSearchParams(location.search).get('sp_feed_ctrl');
    if (override === 'toggle' || override === 'dropdown') {
      ctrl.classList.remove('sp-feed-ctrl--toggle', 'sp-feed-ctrl--dropdown');
      ctrl.classList.add('sp-feed-ctrl--' + override);
    }

    var carousel = section.querySelector('carousel-slider');
    var grid = section.querySelector('.slider__grid');
    var scroller = section.querySelector('.slider');
    var viewAll = ctrl.querySelector('[data-sp-feed-viewall]');
    var toggle = ctrl.querySelector('[data-sp-feed-toggle]');
    var menu = ctrl.querySelector('[data-sp-feed-menu]');
    if (!grid) return;

    var feeds = { newest: grid.innerHTML };
    section.querySelectorAll('template[data-sp-feed-tpl]').forEach(function (t) {
      feeds[t.getAttribute('data-sp-feed-tpl')] = t.innerHTML;
    });
    var baseHref = viewAll ? viewAll.getAttribute('href') : '';
    var baseText = viewAll ? viewAll.textContent.trim() : '';
    var word = menu ? menu.querySelector('.sp-feed-menu__word') : null;
    var popSw = menu ? menu.querySelector('[data-sp-feed-popular]') : null;
    var head = menu ? menu.querySelector('[data-sp-feed-head]') : null;
    var simSw = menu ? menu.querySelector('[data-sp-feed-similar]') : null;
    // multiple"); each category list is a popular list, so any picked category means the sort reads Popular.
    var sort = 'newest';
    var cats = [];
    var shown = 'newest';
    var limit = grid.querySelectorAll('.slider__item').length || 25;

    function handleOf(item) {
      var a = item.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : item.textContent.trim().slice(0, 60);
    }
    function merged(keys) {
      var seen = {}, out = [];
      keys.forEach(function (k) {
        var t = document.createElement('template');
        t.innerHTML = feeds[k] || '';
        Array.prototype.forEach.call(t.content.querySelectorAll('.slider__item'), function (it) {
          var h = handleOf(it);
          if (seen[h] || out.length >= limit) return;
          seen[h] = true;
          out.push(it.outerHTML);
        });
      });
      return out.join('');
    }

    // together, types in the order they first appear, so the row's lead product still leads.
    function grouped(html) {
      var t = document.createElement('template');
      t.innerHTML = html;
      var order = [], groups = {};
      Array.prototype.forEach.call(t.content.querySelectorAll('.slider__item'), function (it) {
        var k = (it.getAttribute('data-sp-type') || '').trim().toLowerCase() || '\u0000' + order.length;
        if (!groups[k]) { groups[k] = []; order.push(k); }
        groups[k].push(it.outerHTML);
      });
      return order.map(function (k) { return groups[k].join(''); }).join('');
    }

    // back in. Opacity only, on the grid element alone (the carousel scrolls, it does not transform the grid).
    // A click mid-fade restarts from the current opacity; reduced motion swaps instantly.
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var swapToken = 0;
    // Each list's cards are parsed once and kept: toggling back moves the same nodes (images already
    // decoded, listeners kept) instead of re-parsing ~120 KB of markup and re-laying out every image.
    var nodeCache = {};
    var inGrid = 'newest'; // the list whose nodes are in the grid right now (shown moves ahead during a fade)
    function nodesFor(key, html) {
      if (!nodeCache[key]) {
        var frag = document.createRange().createContextualFragment(html);
        nodeCache[key] = Array.prototype.slice.call(frag.childNodes);
      }
      return nodeCache[key];
    }
    function applySwap(key, html) {
      if (key === inGrid) return;
      if (!nodeCache[inGrid]) nodeCache[inGrid] = Array.prototype.slice.call(grid.childNodes);
      if (typeof grid.replaceChildren === 'function') grid.replaceChildren.apply(grid, nodesFor(key, html));
      else grid.innerHTML = html;
      inGrid = key;
      if (scroller) scroller.scrollLeft = 0;
      if (carousel && typeof carousel.refresh === 'function') carousel.refresh();
      if (scroller) scroller.dispatchEvent(new Event('scroll'));
    }
    function swap(key, html) {
      if (reduceMotion || typeof grid.animate !== 'function') { applySwap(key, html); return; }
      var token = ++swapToken;
      var from = parseFloat(getComputedStyle(grid).opacity);
      grid.getAnimations().forEach(function (a) { a.cancel(); });
      var fadeOut = grid.animate([{ opacity: isNaN(from) ? 1 : from }, { opacity: 0 }], { duration: 140, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' });
      fadeOut.onfinish = function () {
        if (token !== swapToken) return;
        applySwap(key, html);
        grid.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
        fadeOut.cancel();
      };
    }

    function render() {
      var sim = !!(simSw && simSw.checked);
      var key = (cats.length ? 'cats:' + cats.join(',') : sort) + (sim ? '|similar' : '');
      if (key !== shown) {
        var html = cats.length > 1 ? merged(cats) : feeds[cats.length ? cats[0] : sort] || feeds.newest;
        swap(key, sim ? grouped(html) : html);
        shown = key;
      }
      var effSort = cats.length ? 'top' : sort;
      var on = effSort !== 'newest';
      if (word && !word.querySelector('.sp-feed-menu__w')) word.textContent = on ? 'Shop popular' : 'Shop newest';
      if (viewAll) {
        // Always "View all" to all New arrivals, newest first, whichever way the row is sorted
        viewAll.setAttribute('href', baseHref);
        viewAll.textContent = baseText;
      }
      if (toggle) toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (popSw) popSw.checked = on;
      if (head) head.textContent = on ? 'Shop popular' : 'Sort newest';
      if (menu) {
        menu.classList.toggle('is-active', on);
        menu.querySelectorAll('[data-sp-feed]').forEach(function (b) {
          var k = b.getAttribute('data-sp-feed');
          var checked = /^cat/.test(k) ? cats.indexOf(k) !== -1 : k === effSort;
          b.setAttribute('aria-checked', checked ? 'true' : 'false');
        });
        var summary = menu.querySelector('summary');
        if (summary) summary.setAttribute('aria-label', 'Shop: ' + (on ? 'popular' : 'newest') + (cats.length ? ', ' + cats.length + ' categories' : ''));
      }
    }

    function select(key) {
      if (/^cat/.test(key)) {
        var i = cats.indexOf(key);
        if (i === -1) cats.push(key); else cats.splice(i, 1);
        // keep the menu's order so the merged row is stable whichever box was ticked first
        var order = menu ? Array.prototype.map.call(menu.querySelectorAll('[data-sp-feed^="cat"]'), function (b) { return b.getAttribute('data-sp-feed'); }) : [];
        cats.sort(function (x, y) { return order.indexOf(x) - order.indexOf(y); });
      } else {
        sort = feeds[key] ? key : 'newest';
        cats = [];
      }
      render();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        select(sort === 'newest' && !cats.length ? 'top' : 'newest');
      });
    }

    // the trigger itself flips the row between newest and popular; the caret points up while popular.
    var noPanel = menu && !menu.querySelector('.sp-feed-menu__panel');
    if (noPanel) {
      var trig = menu.querySelector('summary');
      // Warm the other list as the pointer arrives (a click is always a few hundred ms behind it): parse
      // its cards once and start the first visible images, so the swap has nothing to fetch or parse.
      var warm = function () {
        var other = sort === 'newest' ? 'top' : 'newest';
        if (!feeds[other] || nodeCache[other] || other === inGrid) return;
        nodesFor(other, feeds[other]).slice(0, 12).forEach(function (n) {
          var img = n.querySelector && n.querySelector('img');
          if (!img) return;
          var pre = new Image();
          if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
          if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
          if (img.getAttribute('src')) pre.src = img.getAttribute('src');
        });
      };
      if (trig) {
        trig.addEventListener('pointerenter', warm);
        trig.addEventListener('focus', warm);
        trig.addEventListener('click', function (e) {
          e.preventDefault();
          var was = sort === 'newest' && !cats.length ? 'newest' : 'top';
          menu.setAttribute('data-sp-feed-from', was);
          select(was === 'newest' ? 'top' : 'newest');
        });
      }
    }

    if (menu) {
      menu.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sp-feed]');
        if (!b) return;
        var k = b.getAttribute('data-sp-feed');
        select(k);
        // A sort is one choice and closes the menu; a category box keeps it open for more picks.
        if (!/^cat/.test(k)) menu.removeAttribute('open');
      });
      document.addEventListener('click', function (e) {
        if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
      });
      // off on every load; on shows the category boxes. Turning it off clears the picks, so the row falls
      // back to Popular.
      var group = menu.querySelector('[data-sp-feed-group]');
      var catsBox = menu.querySelector('[data-sp-feed-cats]');
      if (group && catsBox) {
        group.checked = false;
        group.addEventListener('change', function () {
          catsBox.hidden = !group.checked;
          if (!group.checked && cats.length) { cats = []; sort = 'top'; render(); }
        });
      }
      if (simSw) {
        simSw.checked = false;
        simSw.addEventListener('change', render);
      }
      // toggle for that option. sort newest is just a label"). Off at load = newest. On = popular, and By
      // category turns on so the category boxes show. Off again = newest; By category is left as it is.
      if (popSw) {
        popSw.checked = false;
        popSw.addEventListener('change', function () {
          if (popSw.checked) {
            select('top');
            if (group && catsBox && !group.checked) { group.checked = true; catsBox.hidden = false; }
          } else {
            select('newest');
          }
        });
      }
      menu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.hasAttribute('open')) {
          menu.removeAttribute('open');
          var s = menu.querySelector('summary');
          if (s) s.focus();
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('.sp-feed-ctrl').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
